import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MailAttachmentDto, MailDetailDto, MailService } from '../mail.service';

@Component({
  selector: 'app-mail-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mail-detail.component.html',
  styleUrl: './mail-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MailDetailComponent {
  @Input() detail!: MailDetailDto;

  constructor(
    public activeModal: NgbActiveModal,
    private mailService: MailService,
    private toastr: ToastrService,
  ) {}

  get headerEntries(): [string, string[]][] {
    return Object.entries(this.detail.headers ?? {});
  }

  downloadRaw(): void {
    this.mailService.getRaw(this.detail.messageId, this.detail.folder).subscribe({
      next: (blob) => this.triggerDownload(blob, `${this.sanitize(this.detail.messageId)}.eml`),
      error: (err) => this.toastr.error('Failed to download raw mail: ' + err.message),
    });
  }

  downloadAttachment(attachment: MailAttachmentDto): void {
    this.mailService.getAttachment(this.detail.messageId, attachment.index, this.detail.folder).subscribe({
      next: (blob) => this.triggerDownload(blob, attachment.fileName ?? `attachment-${attachment.index}`),
      error: (err) => this.toastr.error('Failed to download attachment: ' + err.message),
    });
  }

  private triggerDownload(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  private sanitize(name: string): string {
    return name.replace(/[\\/:*?"<>|]/g, '_');
  }
}
